import useClickOutside from "@/hooks/useClickOutside";
import Image from "next/image";
import React, { useState, useEffect, useRef } from "react";
import languageOptions from "@/data/languageOptions";
import dynamic from "next/dynamic";

const LanguageOptions = dynamic(() => import("./LanguageOptions"), {
  ssr: false,
});
const LanguageCurrencyDropdown = ({ language = "tr", onLanguageChange }) => {
  const refOne = useRef();
  const refTwo = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState(language);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const cookieLang = document.cookie
      .split("; ")
      .find((row) => row.startsWith("googtrans="))
      ?.split("=")[1]
      ?.split("/")[2];

    if (cookieLang && cookieLang !== currentLang) {
      setCurrentLang(cookieLang);
    }
  }, []);

  useEffect(() => {
    // Türkçeye dönüldüğünde script kaldırılır
    if (currentLang === "tr") {
      const gtEl = document.getElementById("google_translate_element");
      if (gtEl) gtEl.innerHTML = ""; // temizle
      const script = document.querySelector(
        'script[src*="translate_a/element.js"]'
      );
      if (script) {
        document.head.removeChild(script);
      }
      return;
    }

    // Diğer diller için script yüklenir
    window.googleTranslateElementInit = function () {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "tr",
          includedLanguages: "tr,en,de",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };

    const script = document.createElement("script");
    script.src =
      "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [currentLang]);

  useClickOutside([refOne, refTwo], () => setIsOpen(false));
  return (
    <>
      <div
        id="google_translate_element"
        className="absolute hidden opacity-0"
      ></div>

      <div className="relative">
        <button
          ref={refOne}
          type="button"
          onClick={toggleDropdown}
          className="flex items-center gap-1.5 cursor-pointer"
        >
          <Image
            src="/icons/earth.svg"
            alt="earth"
            width={20}
            height={20}
            className="object-contain sm:w-5 w-7 sm:h-5 h-7"
          />
          <span className="text-xs font-medium leading-normal text-themeTopbarColor">
            {languageOptions.find((opt) => opt.code === currentLang)?.name ||
              currentLang}
          </span>
        </button>
        {isOpen && (
          <LanguageOptions
            refTwo={refTwo}
            onLanguageChange={onLanguageChange}
            setCurrentLang={setCurrentLang}
            setIsOpen={setIsOpen}
          />
        )}
      </div>
    </>
  );
};

export default LanguageCurrencyDropdown;
